import { doc, updateDoc } from 'firebase/firestore';
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { db } from '../firebase';

const UpdateNotice = () => {
    const location = useLocation();
    const [notice,setNotice] = useState("");
    const [noticeTitle,setNoticeTitle] = useState("");
    const [noticeDate,setNoticeDate] = useState("");
    const navigate = useNavigate();
            
      
    const updateNotice = async () => {
        await updateDoc(doc(db, "noticeAll",location.state.noticeId), {
          noticeTitle : noticeTitle,
          notice : notice,
          noticeDate : noticeDate
        })?.then(()=>{
            window.location.reload(true);
            // console.log("Updated Successfully");
          }); 
      }
  return (
        <div className="h-screen bg-slate-200" >
             <div className='text-left '>
        <button  className='cursor-pointer'
        onClick={()=>navigate(-1)}
        >
          <img src='../assets/back.png'  alt='back' className='h-10 w-h-10'/>
        </button>
      </div>
        <div className=" grid grid-rows-3  justify-center overflow-y-auto p-20">
          <div className=" bg-white rounded-md row-span-2 shadow-lg">
          {/* <div className="w-full  place-self-center rounded-lg  ">
          <div className="flex justify-end">
          <button   onClick={() =>{ setOpenNotice(false)}}
          >
            <img src="../assets/close-button.png" alt="pic" className="h-10 w-10"/>
          </button>
         </div>
           
            </div> */}
            <div className="grid grid-cols-2 mt-10">
            <div className="w-full max-w-sm ml-5">
                  <div className="md:flex md:items-center ">
                    <div className="md:w-1/4">
                      <label
                        className="block text-black font-bold md:text-center mb-1 md:mb-0 pr-4"
                      >
                        Title
                      </label>
                      </div>
                      <div className="md:w-3/5">
                     <input
                      value={noticeTitle}
                      onChange={(e) => {
                        setNoticeTitle(e.target.value);
                      }}
                       type="text"
                       placeholder={noticeTitle}
                        className="block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                       />
                     </div></div></div>
                     <div className="w-full max-w-sm ml-5">
                       <div className="md:flex md:items-center ">
                        <div className="md:w-1/4">
                      <label
                        className="block text-black font-bold md:text-center mb-1 md:mb-0 pr-4"
                      >
                        Date
                      </label>
                      </div>
                        <div className="md:w-1/2">
                             <input
                               value={noticeDate}
                               onChange={(e) => {
                                 setNoticeDate(e.target.value);
                               }}
                           type="date"
                           className="block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                           />
                       </div>
                     </div>
                    </div>
                  </div>
                  <div className="h-52 w-full pr-10 pl-10 ">
              <textarea 
               value={notice}
               onChange={(e) => {
                 setNotice(e.target.value);
               }}
              className="w-full h-40 px-3 mt-3 text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Your message..."/>
              </div>        
            <div className="mx-auto mb-10">
             <button
               className="bg-green-400 p-1 text-2xl text-white font-semibold rounded-lg"
               onClick={updateNotice}
             >
               Submit
             </button>
           </div>
          </div>
        </div>
       
        </div>    
  )
}

export default UpdateNotice